import * as React from 'react';
import { translate } from 'react-i18next';
import * as moment from 'moment';
import * as c from 'models/constants';
import { Periodicity } from 'models/enums/periodicity';
import { PortalSelectMenu } from 'components/FormControls';

require('./style.css');

interface IProps {
	onPeriodicityChange: (val) => void;
	setPeriodForward: () => void;
	setPeriodBackwards: () => void;
	selectedPeriodicity: Periodicity;
	dateFrom: string;
	dateTo: string;
	t?: (key: string, object?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PeriodSelector extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
		this.handleOnBackwardsPeriodClick = this.handleOnBackwardsPeriodClick.bind(this);
		this.handleOnForwardPeriodClick = this.handleOnForwardPeriodClick.bind(this);
		this.showPeriod = this.showPeriod.bind(this);
	}

	private handlePeriodicityChange(val: Periodicity) {
		this.props.onPeriodicityChange(val);
	}

	private handleOnBackwardsPeriodClick() {
		this.props.setPeriodBackwards();
	}

	private handleOnForwardPeriodClick() {
		this.props.setPeriodForward();
	}

	private showPeriod(): JSX.Element {
		let period = null;
		switch (this.props.selectedPeriodicity) {
			case Periodicity.Week:
				period = moment(this.props.dateFrom).format('L') + ' - ' + moment(this.props.dateTo).format('L');
				break;

			case Periodicity.Month:
				period = moment(this.props.dateFrom).format('MMMM') + ' ' + moment(this.props.dateFrom).format('YYYY');
				break;

			case Periodicity.Year:
				period = moment(this.props.dateFrom).format('YYYY');
				break;

			case Periodicity.AllTime:
				period = 'All time';
				break;

			default:
				period = moment(this.props.dateFrom).format('L') + ' - ' + moment(this.props.dateTo).format('L');
		}
		return period;
	}

	public render() {
		const { selectedPeriodicity, t } = this.props;

		const periodicityOptions = [];
		for (const n in Periodicity) {
			if (typeof Periodicity[n] === 'number') {
				periodicityOptions.push({ key: Periodicity[n], value: t('Periodselector_Periodicity_' + Periodicity[n]) });
			}
		}

		const periodicityDropDownInputProps: object = {
			id: 'periodicityDropdown',
			onChange: this.handlePeriodicityChange,
			value: selectedPeriodicity,
			name: 'periodicityDropdown',
		};

		const backButton =
			selectedPeriodicity !== Periodicity.AllTime ? (
				<div className="back" onClick={this.handleOnBackwardsPeriodClick} style={{ cursor: 'pointer' }} />
			) : null;
		const forwardButton =
			selectedPeriodicity !== Periodicity.AllTime ? (
				<div className="forward" onClick={this.handleOnForwardPeriodClick} style={{ cursor: 'pointer' }} />
			) : null;

		return (
			<div className="periodSelector">
				<div className="periodicitySelector">
					<PortalSelectMenu
						input={periodicityDropDownInputProps}
						items={periodicityOptions}
						searchable={false}
						isRequired={true}
					/>
				</div>
				<div className="period">
					{backButton}
					<div className="value">{this.showPeriod()}</div>
					{forwardButton}
				</div>
			</div>
		);
	}
}
export { PeriodSelector };
